import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useRef } from "react"
import { useState } from "react"
import { Link, useSearchParams } from "react-router-dom"
import slika_url from '../../res/images/Default.png'

function Nastavnici({ zaposleni, predmeti, predmetiImena, predmetiSlugs, kategorija, strucnoVece = null }) {
    const [searchParams, setSearchParams] = useSearchParams()
    predmeti.sort((a, b) => { return [predmetiSlugs[a] - predmetiSlugs[b]] })
    // Ako postoji strucnoVece iz URL-a i nalazi se u listi predmeta, koristi ga kao početnu vrednost
    const pocetniPredmet = strucnoVece && predmeti.includes(strucnoVece) ? strucnoVece : predmeti[0]
    const [IPredmet, setIPredmet] = useState(pocetniPredmet)
    const [dropdown, setDropdown] = useState(false)

    // Ažuriraj URL kada se promeni izabrani predmet (stručno veće)
    const updatePredmet = (predmet) => {
        setIPredmet(predmet)
        // Ažuriraj URL sa novim sv parametrom (replace: true da ne dodajemo u istoriju)
        const newParams = new URLSearchParams(searchParams)
        newParams.set('sv', predmet)
        setSearchParams(newParams, { replace: true })
    }

    // Ažuriraj IPredmet kada se strucnoVece promeni (npr. pri navigaciji nazad)
    useEffect(() => {
        if (strucnoVece && predmeti.includes(strucnoVece)) {
            setIPredmet(strucnoVece)
        }
    }, [strucnoVece, predmeti])

    // Pri prvom renderovanju, ako nema sv u URL-u, dodaj ga
    useEffect(() => {
        if (!searchParams.get('sv') && IPredmet) {
            const newParams = new URLSearchParams(searchParams)
            newParams.set('sv', IPredmet)
            setSearchParams(newParams, { replace: true })
        }
        // Skroluj do sredine stranice (dropdown sekcija)
        window.scrollTo(0, 300)
    }, [])

    let predmetiEl = useRef(null)

    let findIndex = (predmetId) => {
        for (let i = 0; i < predmeti.length; i++) {
            if (predmeti[i] === predmetId) {
                return i;
            }
        }
        return -1;
    }

    return <>
        <div className="nastavnici-wrapper">
            <div className="predmet-select-wrapper">
                {/* <h1>{dropdown ? 'true' : 'false'}</h1> */}
                <div className="izabrani" onClick={() => {
                    setDropdown(!dropdown);
                }} style={{ cursor: 'pointer' }}>
                    <h1>{predmetiImena[IPredmet]}</h1>
                    <FontAwesomeIcon icon={faChevronDown} id={dropdown ? 'rotacija' : ''} />
                </div>
                <ul className="predmeti" id={dropdown ? 'visible' : 'invisible'}>
                    <div>
                        {predmeti.map((predmet) => {
                            return <li onClick={() => { updatePredmet(predmet); setDropdown(!dropdown); window.scrollTo(0, 300) }} style={{ cursor: 'pointer' }} id={predmet == IPredmet ? 'izabran' : ''}>{predmetiImena[predmet]}</li>
                        })}
                    </div>
                </ul>
            </div>
            <div className="layout">
                {zaposleni.map((zaposljen) => {
                    if (zaposljen == null || !zaposljen['predmeti'].includes(IPredmet)) return <></>
                    return <>
                        <div>
                            <div>
                                <img src={zaposljen['slika'] ? zaposljen['slika'] : slika_url}></img>
                                <Link to={`/kolektiv/${zaposljen['id']}?kat=${encodeURIComponent(kategorija)}&sv=${encodeURIComponent(IPredmet)}`}></Link>
                            </div>
                            <Link to={`/kolektiv/${zaposljen['id']}?kat=${encodeURIComponent(kategorija)}&sv=${encodeURIComponent(IPredmet)}`}>{zaposljen['ime']}</Link>
                        </div>
                    </>
                })}
            </div>
        </div>
    </>
}

export default Nastavnici